import { useState } from "react";
import { api, formatApiErrorDetail, setToken, clearToken } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { PasswordInput } from "@/components/PasswordInput";
import { toast } from "sonner";
import { KeyRound, LogOut } from "lucide-react";

export default function ChangePasswordFirst() {
  const { logout } = useAuth();
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (f.new_password.length < 8) { toast.error("Password baru minimal 8 karakter"); return; }
    if (f.new_password !== f.confirm) { toast.error("Konfirmasi password tidak cocok"); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      if (data.token) setToken(data.token); else clearToken();
      toast.success(data.token ? "Password diperbarui. Silakan lanjut." : "Password diperbarui. Silakan login ulang.");
      window.location.href = data.token ? "/" : "/login";
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-[#050B14] px-4 py-8">
      <div className="w-full max-w-sm rounded-2xl border border-white/10 bg-[#0a1830] p-6 shadow-2xl" data-testid="force-change-page">
        <div className="mb-4 flex items-center gap-2.5">
          <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-amber-500/15 text-amber-300 ring-1 ring-inset ring-amber-400/30"><KeyRound size={22} /></span>
          <div><h1 className="font-heading text-lg font-extrabold text-white">Ganti Password</h1><p className="text-[11px] text-[#AAB8CC]">Wajib diganti pada login pertama</p></div>
        </div>
        <form onSubmit={submit} className="space-y-3">
          <div><Label className="text-xs text-slate-300">Password saat ini</Label><PasswordInput data-testid="fc-current" value={f.current_password} onChange={(e) => setF({ ...f, current_password: e.target.value })} required className="mt-1.5 h-11 border-white/12 bg-white/5 text-white" /></div>
          <div><Label className="text-xs text-slate-300">Password baru (min 8)</Label><PasswordInput data-testid="fc-new" value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} minLength={8} required className="mt-1.5 h-11 border-white/12 bg-white/5 text-white" /></div>
          <div><Label className="text-xs text-slate-300">Ulangi password baru</Label><PasswordInput data-testid="fc-confirm" value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} required className="mt-1.5 h-11 border-white/12 bg-white/5 text-white" /></div>
          <Button type="submit" data-testid="fc-submit" disabled={busy} className="h-11 w-full bg-blue-600 font-semibold text-white hover:bg-blue-500">{busy ? "Menyimpan…" : "Simpan & Lanjut"}</Button>
        </form>
        <button data-testid="fc-logout" onClick={logout} className="mt-3 flex w-full items-center justify-center gap-1.5 text-xs font-medium text-slate-400 hover:text-blue-300"><LogOut size={13} /> Keluar</button>
      </div>
    </div>
  );
}
